


















import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";

@Component({
  components: {},
})
export default class CacatTubuh extends Vue {
  @Prop() setCacatTubuh: string;
  @Prop() setLabel!: string;
  // validasi = [(v) => !!v || "*Kolom ini harus diisi"];
  label = "";
  placeholder = this.setLabel;
  // get alergi() {
  //   return this.setAlergi;
  // }
  // set alergi(value) {
  //   this.$emit("alergi", value);
  // }
  @Watch("setCacatTubuh")
  changeAlergi(v) {
    if (this.setLabel == "") {
      this.label = "";
      this.placeholder = "";
    } else {
      if (v == "" || v == null) {
        this.label = "";
        this.placeholder = this.setLabel;
      } else {
        this.label = this.setLabel;
        this.placeholder = "";
      }
    }
    this.$emit("cacattubuh", v);
    // console.log(v);
    this.setCacatTubuh = v;
  }
}
